// TODO: MOVE interface to packages ui
export const getMeasurementTotalLogged = (measurements: any[]) => {
  const total = measurements.reduce((acc, curr) => acc + curr.amount, 0);

  return total;
};
